export const organisationLogoUrl = (fileId?: string): string | undefined =>
  fileId ? `${import.meta.env.VITE_APP_BASE_API_ENDPOINT}/organisation/logo/${fileId}` : undefined;
